import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { PaginationInfo } from "../../models/loan.model";

import { createStyles, makeStyles } from "@material-ui/core";
import { Button, Grid } from "@mui/material";
import {
  FILTER_CACHE,
  NATIONAL,
  SUPPLIERIDS,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  SUPPLIER_ID,
  TABLE_FILTER,
  TABLE_FILTER_ROWNUMBERREQCMP,
} from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import createCache from "@emotion/cache";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import { createTheme } from "@mui/material/styles";
import { useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
// import { Pagination } from "@mui/material";

import { CacheProvider, ThemeProvider } from "@emotion/react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Formik } from "formik";
import { connect, useSelector } from "react-redux";
import ChipCmp from "../../components/chip/chipCmp";
import AutocomplateCheckbox from "../../components/dropdown/AutocomplateCheckbox";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  Filter,
  GetSupplierSettlementItemsRequest,
  GetSupplierSettlementItemsResponse,
} from "../../models/cartable.model";
import { GetSuppliers } from "../../services/basicInformation.service";
import { GetRegisterBySupplierItems } from "../../services/cartable.service";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Next.png' />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Previous.png' />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "assigner", label: "ارجاع دهنده" },
  { id: "customerFullName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "customerMobileNumber",
    label: "شماره موبایل",
  },
  {
    id: "requestDatePersian",
    label: "تاریخ ثبت",
  },
  {
    id: "loanTemplateTitle",
    label: "طرح ",
  },
  {
    id: "supplierName",
    label: " تامین کننده کالا ",
  },
  {
    id: "financialSupplierTitle",
    label: " تامین کننده مالی ",
  },
  {
    id: "loanAmount",
    label: "مبلغ  (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "profitRate",
    label: "سود ",
    hasFormat: true,
    format: (vlaue: number) => {
      return `%${vlaue}`;
    },
  },
  {
    id: "loanRequestSourceTitle",
    label: "منبع درخواست",
  },
];

let muiSelected: any;

function TableRegBySuppCmp({ stateCartable, status }: TableCmpPropsInterface) {
  /*********** filter added */
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueSupplierIds, setValueSupplierIds] = useState<string[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();

  function changeValueSupplierIds(e: any, value: any) {
    queryClient.setQueryData(SUPPLIER_ID, e);
    setValueSupplierIds(e);
    setValueSupplier(value);
    queryClient.setQueryData(FILTER_CACHE, value);
  }
  useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
    onSuccess(data) {
      setSupplierIdsOptions(data);
    },
  });
  const setChildValueSupplierIds = (childValues: any) => {
    const selectedItem = valueSupplierIds.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueSupplier.filter(
      (item: any) => item.id != childValues
    );
    queryClient.setQueryData(SUPPLIER_ID, selectedItem);
    setValueSupplierIds(selectedItem);
    setValueSupplier(selectedItemValue);
    queryClient.setQueryData(FILTER_CACHE, selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierIds = tabelFilter!.supplierIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }

    fillData(tabelFilter!);
  };
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    queryClient.setQueryData<string>(NATIONAL, selectedItem);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };
  function changeValueCustomerNationalCode(e: any) {
    queryClient.setQueryData<string>(NATIONAL, e.currentTarget.value);
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  /*********** filter added */

  let row: any;
  const queryClient = useQueryClient();
  const oldPage = queryClient.getQueryData<Filter>(
    TABLE_FILTER_ROWNUMBERREQCMP
  );
  const activePage = localStorage.getItem("setActivePage");

  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    loanRequestId: number;
    natinalCode: string;
  }>();

  const [selectedRow, setSelectedRow] = useState(undefined);

  const [data, setData] = React.useState<GetSupplierSettlementItemsResponse[]>(
    []
  );
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  const disposeListener = history.listen((navData) => {
    if (
      navData.pathname.includes("/loan/LoanRegistrationBySupplier") &&
      history.location.state !== undefined &&
      history.location.state.pageNumber!
    ) {
      currentPaginationInfo.pageNumber = history.location.state.pageNumber;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  });

  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_ROWNUMBERREQCMP);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_ROWNUMBERREQCMP);
      setSelectedRow(row?.rowNumber);
    }
    const filter = new Filter();
    filter.state = stateCartable.stateCartable;
    let nationalCache = queryClient.getQueryData<string>(NATIONAL);
    let suppIdCache = queryClient.getQueryData<string[]>(SUPPLIER_ID);
    filter.customerNationalCode = nationalCache;
    filter.supplierIds = suppIdCache;
    if (stateCartable.stateCartable) {
      fillData(filter);
    }
    queryClient.setQueryData(TABLE_FILTER, filter);
    queryClient.setQueryData(TABLE_FILTER_ROWNUMBERREQCMP, filter);
  }, [stateCartable]);
  React.useEffect(() => {
    ////test bug
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        if (filterData.supplierIds?.length! > 0) {
          setValueSupplierIds(filterData?.supplierIds!);

          setValueSupplier(queryClient.getQueryData(FILTER_CACHE)!);
        }
        if (
          filterData.customerNationalCode !== undefined &&
          filterData.customerNationalCode !== null
        ) {
          setValueCustomerNationalCode(filterData?.customerNationalCode!);
        }
      }
    } else {
      filterData = new Filter();
      filterData.customerNationalCode = "";
      filterData.supplierIds = [];

      queryClient.setQueryData(TABLE_FILTER, null);
    }
    queryClient.setQueryData("STATECARTABLE_REG", stateCartable.stateCartable);
    ////test bug
  }, []);
  const GetRegisterBySupplierItemsMutation = useMutation(
    GetRegisterBySupplierItems,
    {
      onSuccess: (
        result: ApiResultModel<GetSupplierSettlementItemsResponse[]>
      ) => {
        if (result) {
          setData(result.data);
          setPageInfo(result.pageInfo);
        }
      },
    }
  );

  const generateFilter = (
    filterData: Filter
  ): GetSupplierSettlementItemsRequest => {
    let request = new GetSupplierSettlementItemsRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    //checked
    if (request.filter != undefined && request.filter != null) {
      request.filter.state = stateCartable?.stateCartable;
    } else {
      const filter = new Filter();
      filter.state = stateCartable.stateCartable;
      if (stateCartable.stateCartable) {
        request.filter = filter;
      }
    }
    if (
      queryClient.getQueryData("STATECARTABLE_REG") !=
      stateCartable.stateCartable
      // oldPage?.state != stateCartable.stateCartable
    ) {
      currentPaginationInfo.pageNumber = 1;
      setCurrentPaginationInfo(currentPaginationInfo);
      queryClient.setQueryData(
        "STATECARTABLE_REG",
        stateCartable.stateCartable
      );
    }

    return request;
  };
  React.useEffect(() => {
    if (history.action === "POP") {
      currentPaginationInfo.pageNumber = 1;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  }, [stateCartable.stateCartable]);
  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetRegisterBySupplierItemsMutation.mutate(filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    // fillData(new Filter())
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleDetail = (
    referenceKey: string,
    rowIndex: number,
    loanRequestId: number,
    natinalCode: string
  ) => {
    window.sessionStorage.setItem("id", referenceKey);
    window.sessionStorage.setItem("loanRequestId", loanRequestId.toString());
    window.sessionStorage.setItem("natinalCode", natinalCode);
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);

    history.push({
      pathname: `/loan/${activePage}1/loan-detail`,
      state: {
        id: referenceKey,
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
        loanRequestId: loanRequestId,
        natinalCode: natinalCode,
      },
    });
  };

  function deleteChip() {
    setValueSupplierIds([]);
    queryClient.setQueryData(SUPPLIER_ID, []);
    queryClient.setQueryData(FILTER_CACHE, []);
    setValueSupplier([]);
    setValueCustomerNationalCode("");
    queryClient.setQueryData<string>(NATIONAL, "");
    queryClient.setQueryData(SUPPLIER_ID, null);
    const filter = new Filter();
    filter.state = stateCartable.stateCartable;
    fillData(filter);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
    queryClient.setQueryData(TABLE_FILTER, null);
  }
  const filter = new Filter();
  filter.state = " []";

  const lessFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
      فیلترهای کمتر{" "}
    </span>
  );
  const extraFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
      فیلترهای بیشتر
    </span>
  );

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };

  const handleSelectRow = (rowIndex: any) => {
    const filter = new Filter();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    // queryClient.setQueryData(TABLE_FILTER, filter);
    queryClient.setQueryData(TABLE_FILTER_ROWNUMBERREQCMP, filter);
  };

  return (
    <>
      <Formik
        initialValues={filter}
        onSubmit={(values: any) => {
          values.supplierIds = valueSupplierIds;
          values.supplierName = valueSupplier;
          values.state = stateCartable.stateCartable;
          values.customerNationalCode = valueCustomerNationalCode;
          queryClient.setQueryData(TABLE_FILTER, values);
          fillData(values);
          currentPaginationInfo.pageNumber = 1;
          setCurrentPaginationInfo(currentPaginationInfo);
        }}
      >
        {({ handleSubmit, handleChange, values }) => (
          <form onSubmit={handleSubmit} onChange={handleChange}>
            <div className='row' style={{ paddingBottom: " 5px " }}>
              <div
                className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                style={{ margin: " 1vh" }}
              >
                <CacheProvider value={cacheRtl}>
                  <ThemeProvider theme={theme}>
                    <div>
                      <AutocomplateCheckbox
                        id='supplierIds'
                        name='supplierIds'
                        value={valueSupplierIds}
                        label='پذیرنده'
                        options={supplierIdsOptions}
                        onChange={changeValueSupplierIds}
                        changeMultiSelect={changeValueSupplierIds}
                        responseValue={valueSupplier}
                      />
                    </div>
                  </ThemeProvider>
                </CacheProvider>
              </div>
              <div
                className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                style={{ marginTop: "1vh" }}
              >
                <MaterialTextFieldComponent
                  // className="shadowTextField"
                  helperText={""}
                  placeHolder={"کد ملی"}
                  label={"کد ملی "}
                  required={false}
                  value={valueCustomerNationalCode}
                  onChange={changeValueCustomerNationalCode}
                  name='customerNationalCode'
                  id='customerNationalCode'
                />
              </div>
              <div
                className=' col-4  col-lg-2 col-md-3  butFilter'
                style={{ marginTop: "1vh" }}
              >
                <Button
                  fullWidth
                  variant='contained'
                  type='submit'
                  className='btnForm SuccessDefault  '
                >
                  فیلتر
                </Button>
              </div>
            </div>
            {valueSupplierIds?.length || valueCustomerNationalCode ? (
              <div
                className='row tableCMP'
                style={{ marginBottom: "10px", marginTop: "0" }}
              >
                <Grid container xs={12}>
                  <Grid item xs={12} sm={0.5}>
                    <Button
                      onClick={deleteChip}
                      style={{
                        justifyContent: "right",
                        minWidth: "25px",
                        marginRight: "-1vh",
                      }}
                    >
                      <img
                        style={{ height: "24px", width: "24px" }}
                        src='images/RemoveAllFilters.svg'
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={11.5} style={{ marginTop: "-9px" }}>
                    <ChipCmp
                      item={valueSupplierIds}
                      enamValue={supplierIdsOptions}
                      index={valueSupplierIds?.length}
                      setChildValue={setChildValueSupplierIds}
                    />
                    <ChipCmp
                      item={valueCustomerNationalCode}
                      enamValue={valueCustomerNationalCode}
                      index={valueCustomerNationalCode?.length}
                      setChildValue={setChildValueCustomerNationalCode}
                    />
                  </Grid>
                </Grid>
                <br />
              </div>
            ) : null}
          </form>
        )}
      </Formik>

      <div className='cardTableBorder'>
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className='boxScroll'
        >
          <Table
            stickyHeader
            aria-label='sticky table'
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight'
                  align='right'
                ></TableCell>
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight'
                  align='right'
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {/* <StarsIcon scale="scale(1.8) " style={{ color: "#1D4A87" }} /> */}
                {columns.map((column) => (
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight noWrap'
                    key={column.id}
                    align='right'
                  >
                    {column.label}
                  </TableCell>
                ))}

                <TableCell className='rowTHead colorTitle' align='right'>
                  <span className='colorTitle textFont12 fontWeight'>
                    وضعیت تسویه
                  </span>
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        key={row.loanRequestId}
                        selected={selectedRow === rowIndex}
                        onClick={() =>
                          handleDetail(
                            row.referenceKey,
                            rowIndex,
                            row.loanRequestId,
                            row.customerNationalCode
                          )
                        }
                      >
                        <TableCell className='textFont12' align='right'>
                          {row.isInUserCartable ? (
                            <EmojiObjectsIcon
                              style={{ color: "#fbc02d", fontSize: "25px" }}
                            />
                          ) : (
                            <EmojiObjectsOutlinedIcon
                              style={{ color: "#C1C7CB", fontSize: "25px" }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          className='textFont12'
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetSupplierSettlementItemsResponse
                            ];
                          return (
                            <TableCell
                              className='textFont12'
                              key={column.id}
                              align='right'
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value.toString()}
                            </TableCell>
                          );
                        })}

                        <TableCell className='textFont12' align='right'>
                          <span
                            className={
                              "badge " +
                              (row.supplierSettlementStatusColor
                                ? row.supplierSettlementStatusColor ===
                                  "GreenLable"
                                  ? "badge-success"
                                  : "badge-danger"
                                : "badge-light")
                            }
                          >
                            {row.supplierSettlementStatusTitle}
                          </span>
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems='center'>
          <Grid
            item
            xs={12}
            sm={4}
            display='flex'
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display='flex' justifyContent='center'>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(TableRegBySuppCmp));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
